import { css } from 'styled-components';

const Variables = css`
  :root {
    /* --space-small-x2: 4px;
    --space-small: 8px;
    --space-small-2x: 16px;
    --space-medium: 24px;
    --space-large: 32px;
    --dashboard-header-height: 60px;
    --side-menu-width-collapsed: 60px;
    --side-menu-width: 280px; */
  }
  :root {
    --white: #ffffff;
    --black: #000000;
    --radical-red: #ff3d57;
    --catalina-blue: #032170;
    --mine-shaft: #292929;
    --silver: #c9c9c9;
    --silver-light: #c5c5c5;
    --silver-light-2: #cbcbcb;
    --mercury: #e6e5e5;
    --boulder: #7a7a7a;
    --alto: #d9d9d9;
    --wild-sand: #f6f6f6;
  }
  :root {
    --primary: var(--catalina-blue);
    --text-color-1: var(--mine-shaft);
    --color-1: var(--silver);
    --color-2: var(--mercury);
    --color-3: var(--alto);
    --color-4: var(--boulder);
    --color-5: var(--silver-light);
    --color-6: var(--silver-light-2);
    --color-7: var(--wild-sand);
  }

  /* HireMe Agency design tokens (from Figma) */
  :root {
    --agency-font-heading: 'Space Grotesk', 'Inter', sans-serif;
    --agency-font-body: 'DM Sans', 'Inter', sans-serif;

    --agency-navy: #032170;
    --agency-heading-dark: #191f2e;
    --agency-text-strong: #0a0a0a;
    --agency-text-muted: #4a5565;
    --agency-text-muted-2: #6a7181;
    --agency-text-muted-3: #6a7282;

    --agency-bg-page: #f9fafb;
    --agency-bg-card: #ffffff;
    --agency-bg-pill: #f3f4f6;
    --agency-bg-pill-blue: #eff6ff;
    --agency-text-pill-blue: #1447e6;

    --agency-border: #e5e7eb;
    --agency-border-strong: #d1d5dc;

    --agency-link-teal: #00bba7;

    --agency-score-green-bg: #f0fdf4;
    --agency-score-green-border: #b9f8cf;
    --agency-score-green-text: #008236;

    --agency-score-yellow-bg: #fffbeb;
    --agency-score-yellow-border: #fee685;
    --agency-score-yellow-text: #bb4d00;

    --agency-score-red-bg: #fef2f2;
    --agency-score-red-border: #ffa2a2;
    --agency-score-red-text: #c10007;

    --agency-status-invited-bg: #eff6ff;
    --agency-status-invited-text: #1447e6;
    --agency-status-screening-bg: #fffbeb;
    --agency-status-screening-text: #bb4d00;
    --agency-status-screened-bg: #f5f3ff;
    --agency-status-screened-text: #6d28d9;
    --agency-status-ready-bg: #f0fdf4;
    --agency-status-ready-text: #008236;
    --agency-status-notinvited-bg: #f3f4f6;
    --agency-status-notinvited-text: #4a5565;

    --agency-link-blue: #155dfc;
    --agency-whatsapp-green: #16a34a;

    --agency-radius-sm: 4px;
    --agency-radius-md: 6px;
    --agency-radius-lg: 10px;
  }
`;

export default Variables;
